"use client";
import { appArticleRead } from "@/entities";
import { Loader } from "@/shared";
import PostBackButton from "@/shared/app/ui/post/PostBackButton";
import PostPrevNextNav from "@/shared/app/ui/post/PostPrevNextNav";
import PostShareButton from "@/shared/app/ui/post/PostShareButton";
import PostTitle from "@/shared/app/ui/post/PostTitle";

import { useQuery } from "@tanstack/react-query";
import { useParams, useRouter, useSearchParams } from "next/navigation";

export function NewsViewPage() {
  const router = useRouter();
  const params = useParams<{ id: string }>();
  const searchParams = useSearchParams();

  const id = params?.id || "";

  const { error, isLoading, data } = useQuery({
    queryKey: [`app-articles-${id}`],
    queryFn: () => appArticleRead({ id }),
  });

  if (error) return <>error: {error.message}</>;
  // if (isLoading) return <>loading...</>;

  const categoryColors: Record<string, string> = {
    모집: "bg-[var(--color-label-blue)]",
    공지: "bg-[var(--color-label-red)]",
    소식: "bg-[var(--color-label-gray)]",
  };

  const categoryName = data?.result.common_category?.name || "";
  const categoryBg = categoryColors[categoryName] || "bg-gray-200"; // 기본값 설정

  return (
    <>
      <div className="border-t border-[#ECECEC] mt-[-2px]">
        <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-[100px]">
          {isLoading ? (
            <Loader className="my-100" />
          ) : (
            <>
              {/* 포스트 타이틀 */}
              <PostTitle
                categoryName={data?.result.common_category?.name ?? ""}
                categoryBg={categoryBg}
                title={data?.result.title ?? ""}
                createdAt={data?.result.created_at ?? ""}
              />

              {/* 포스트 컨텐츠 */}

              <div>
                {/* 포스트 공유하기 */}
                <div className="justify-end flex py-5">
                  <PostShareButton article={data?.result} />
                </div>
                <div className="pb-10">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: data?.result.desc ?? "",
                    }}
                  />
                </div>

                {/*  포스트 수정 삭제 버튼 */}
                {/* <PostActionWrap isAdmin /> */}
              </div>

              {/* 포스트 목록으로 */}
              <PostBackButton
                onClick={() =>
                  router.push(`/app/news?${searchParams?.toString() || ""}`)
                }
              />
              {/* 포스트 이전글 다음글 */}
              <PostPrevNextNav />
            </>
          )}
        </div>
      </div>
    </>
  );
}
